import BulkDeliveryGuaranteePanel from './bulk-delivery-guarantee-panel';

export default BulkDeliveryGuaranteePanel;
